import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-schliesszeiten mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = { class: "d-flex justify-content-between justify-content-sm-start align-items-center btn-calendar mt-4" }
const _hoisted_6 = { class: "m-0 mr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_links",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_rechts",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = { class: "sr-only" }
const _hoisted_11 = { class: "col-12 d-flex justify-content-end mt-2 mt-sm-0 px-0" }
const _hoisted_12 = {
  key: 0,
  class: "reports list-unstyled row mx-auto p-inline-start-0"
}
const _hoisted_13 = { class: "holiday-info" }
const _hoisted_14 = { class: "font-weight-bold mr-2" }
const _hoisted_15 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_16 = {
  key: 1,
  class: "teres-alert mt-3",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_link_add_element = _resolveComponent("link-add-element")!
  const _component_link_default = _resolveComponent("link-default")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.holidayList.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/",
      i18nMessage: "common.backToDashboard"
    }),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.year), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.decrementYear()), ["prevent"])),
            class: "btn btn-brand1"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('views.holidayList.decrementYear')), 1)
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.incrementYear()), ["prevent"])),
            class: "btn btn-brand1"
          }, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('views.holidayList.incrementYear')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_link_add_element, {
            i18nMessage: "common.holiday.addIcal",
            to: "/holiday-import",
            class: "mr-3"
          }),
          _createVNode(_component_link_add_element, {
            i18nMessage: "common.holiday.add",
            to: "/holiday-add"
          })
        ]),
        (_ctx.holidays.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holidays, (holiday, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "col-12 d-flex align-items-center"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(holiday.date), 1),
                    _createTextVNode(" " + _toDisplayString(holiday.name) + " " + _toDisplayString(holiday.description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_link_default, {
                      i18nMessage: "common.holiday.edit",
                      to: { name: 'admin-holiday-edit', params: { id: holiday.id } },
                      iconOnly: true,
                      iconClass: "icon-editieren",
                      class: "btn mr-2"
                    }, null, 8, ["to"]),
                    _createVNode(_component_button_delete, {
                      onClick: _withModifiers(($event: any) => (_ctx.remove(holiday)), ["prevent"]),
                      iconOnly: true,
                      class: "no-btn-border"
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!(_ctx.holidays.length > 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_feedback_message, {
                message: _ctx.$t('views.holidayList.noHolidays', { msg: _ctx.year })
              }, null, 8, ["message"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}